<template>
  <div ref="baseAccordion" :class="[bemBlock, expanded ? 'expanded' : '']">
    <button
      ref="baseAccordionButton"
      :aria-expanded="[expanded ? 'true' : 'false']"
      :class="[bemElement('title'), 'btn', 'btn--primary']"
      data-interaction="expand"
      data-interaction-relation="sibling"
      @click="toggleExpand"
    >
      <h2>{{ title }}</h2>
    </button>
    <div
      :class="[bemElement('content'), 'interaction--expand']"
      data-interaction-dependant="true"
    >
      <slot />
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div v-if="contentAssetContent" v-html="contentAssetContent" />
    </div>
  </div>
</template>

<script>
import Axios from 'axios';
import bemClassesMixin from '../mixins/bemClassesMixin';
import { toggle } from '../../interactions/expand';
import getAnalyticsEventBus from '../../common/getAnalyticsEventBus';

const analyticsEventBus = getAnalyticsEventBus();

export default {
  name: 'BaseAccordion',

  mixins: [bemClassesMixin],

  props: {
    title: {
      type: String,
      required: true,
    },
    defaultExpanded: {
      type: Boolean,
      default: false,
    },
    groupName: {
      type: String,
      default: '',
    },
    contentAssetId: {
      type: String,
      default: '',
    },
    getContentAsset: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      contentAssetContent: '',
      expanded: this.defaultExpanded,
    };
  },

  mounted() {
    this.$eventBus?.$on(
      'base-accordion:toggle-expand',
      this.closeOtherSiblingAccordions
    );
    this.loadContentAsset();
  },

  beforeDestroy() {
    this.$eventBus?.$off(
      'base-accordion:toggle-expand',
      this.closeOtherSiblingAccordions
    );
  },

  methods: {
    toggleExpand() {
      this.$eventBus.$emit('base-accordion:toggle-expand', {
        groupNameToToggle: this.groupName,
        accordionExpanded: this.$refs.baseAccordion,
      });
      this.expanded = !this.expanded;
      this.$emit('toggle', this.expanded);
      // Send info for Analytics
      let item;
      if (this.contentAssetId === 'deliveryAndReturns') {
        item =
          analyticsEventBus.EVENTS.PAYLOADS.productDetailsItemClicked.item
            .deliveryReturns;
      } else if (this.contentAssetId === 'paymentMethods') {
        item =
          analyticsEventBus.EVENTS.PAYLOADS.productDetailsItemClicked.item
            .paymentMethod;
      } else {
        item =
          analyticsEventBus.EVENTS.PAYLOADS.productDetailsItemClicked.item
            .details;
      }
      analyticsEventBus.publish(
        analyticsEventBus.EVENTS.productDetailsItemClicked,
        item
      );
    },
    closeOtherSiblingAccordions({ groupNameToToggle, accordionExpanded }) {
      if (
        groupNameToToggle === this.groupName &&
        this.$refs.baseAccordion !== accordionExpanded
      ) {
        if (!accordionExpanded && this.expanded) {
          toggle(
            this.$refs.baseAccordionContent,
            this.$refs.baseAccordionButton
          );
        }
        this.expanded = false;
      }
    },
    loadContentAsset() {
      if (this.contentAssetId?.length > 0 && this.getContentAsset?.length > 0) {
        const url = this.getContentAsset;
        Axios.get(url, {
          params: {
            id: this.contentAssetId,
          },
        })
          .then((response) => {
            this.contentAssetContent = response.data?.content;
          })
          .catch((error) => {
            console.log(error.response?.data?.message);
          });
      }
    },
  },
};
</script>
